import { mainnet, sepolia } from "@account-kit/infra";

const ACCOUNT_KIT_API_KEY = '2O33Fxqgm5BQU8GDn0y7H37bEGFNo02P';
const WALLET_CONNECT_PROJECT_ID = '5abaec90f158fec2947edd5554b7a925';
const API_BASE_URL = 'https://www.thinkagents.ai';
const WEB3_API_BASE_URL = 'https://www.thinkagents.ai';
const WALLET_LOGIN = false;
const PRIMARY_CHAIN = sepolia; // TODO change when ready to mainnet
const ALCHEMY_KEY = `wss://eth-sepolia.g.alchemy.com/v2/${ACCOUNT_KIT_API_KEY}`;
const MINT_HEADER = false;

export default {
    API_BASE_URL,
    WEB3_API_BASE_URL,
    WALLET_LOGIN,
    WALLET_CONNECT_PROJECT_ID,
    ACCOUNT_KIT_API_KEY,
    PRIMARY_CHAIN,
    ALCHEMY_KEY,
    MINT_HEADER
};
  